import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import NodeLoader from "./NodeLoader";

// Compact, consultative advisor card near the assessment content.
export const AdvisorPanel = ({ message, reduced = false }) => (
  <div
    className="rounded-xl border border-white/10 p-4 sm:p-5 mb-6"
    style={{ backgroundColor: "#0F1424" }}
    data-testid="advisor-panel"
    aria-live="polite"
  >
    <div className="flex items-start gap-3">
      <span className="shrink-0 rounded-lg bg-[#1E6BFF]/15 p-2">
        <NodeLoader size={22} reduced={reduced} />
      </span>
      <div className="min-w-0">
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#66B2FF] font-semibold mb-1">
          TeamBuilder AI Advisor
        </div>
        <AnimatePresence mode="wait">
          <motion.p
            key={message || "idle"}
            initial={reduced ? false : { opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={reduced ? undefined : { opacity: 0, y: -4 }}
            transition={{ duration: 0.3 }}
            className="text-white/75 text-sm leading-relaxed"
          >
            {message ||
              "Make a selection and I'll interpret what it means for your workforce plan."}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  </div>
);

export default AdvisorPanel;
